module.exports = __webpack_public_path__ + "static/Wide-4ddefac4f361f352f7848af73a60c93b.woff2";